export default __webpack_public_path__ + "static/media/tooltip_outline.f2f94f96.svg";